<template>
  <div class="company">
    <div class="product-box">
      <div class="title">
        {{ resDatas.title }}
      </div>
      <div class="company-box">
        <div class="company-main">
          <div class="content-html" v-html="resDatas.content"></div>
          <!-- <img class="gameIcon"  src='@/assets/images/about.png'> -->
          <ul>
            <li v-for="(item, index) in resDatas.companyDets" :key="index">
              <span>{{ item.label }}</span><span><em v-if="item.img"><img
                    :src="require('@/assets/images/' + item.img + '')" alt=""></br> </em> <a :href="item.url"
                  target="_blank">{{ item.url }}</a> {{ item.content }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resDatas: "",
    };
  },
  props: {
    resData: {},
  },
  watch: {
    resData(newData) {
      console.log("newData", newData);
      this.resDatas = newData;
    },
  },
  mounted() {
    this.$parent.getlan();
  },
};
</script>

<style scoped>
.company {
  background: url('~@/assets/images/news/bg3.jpg') top center no-repeat;
  background-size: cover;
  padding: 5% 0 5%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-box {
  width: 100%;
}

.company-box {
  max-width: 80%;
  margin: 5% auto;
  background-color: rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  padding: 5% 10%;
  -webkit-box-shadow: 3px 0px 24px 8px rgba(39, 27, 8, 0.31);
  box-shadow: 3px 0px 24px 8px rgba(39, 27, 8, 0.31);
  border-radius: 10px;
}

.title {
  font-size: 70px;
  font-weight: 600;
  text-align: center;
  background: url("~@/assets/images/title-bottom.png") center bottom no-repeat;
  background-size: auto;
  text-shadow: 3px 3px 3px white;
  padding-bottom: 14px;
  font-family: "dbtfont";
}

.liter-title {
  text-align: center;
  margin-top: 2%;
}

.company-main {
  margin-top: 3%;
  font-size: 26px;
}

.company-main ul {
  margin-top: 7%;
}

.gameIcon {
  max-width: 100%;
  margin-top: 4%;
}

.company-main li {
  display: block;
  padding: 2%;
  font-size: 0;
  box-sizing: border-box;
}

.company-main li:nth-of-type(2n + 1) {
  background-color: #ebebeb;
}

.company-main li span {
  display: inline-block;
  font-size: 20px;
  font-weight: 600;
  vertical-align: middle;
  word-break: break-all;
  box-sizing: border-box;
}

.company-main li span:nth-of-type(1) {
  width: 34%;
  text-align: center;
}

.company-main li span:nth-of-type(2) {
  width: 66%;
  color: #818181;
  padding: 0 1%;
}

.company-main li span img {
  width: 35%;
  vertical-align: middle;
}

@media screen and (max-width: 1000px) {
  .company {
    width: 100%;
    box-sizing: border-box;
    background: url('~@/assets/images/news/h5-bg3.jpg') top center no-repeat;
    background-size: 100%;
    padding: 0 5% 5%;
    padding-top: 15%;
    padding-bottom: 15%;
  }

  .company-main {
    font-size: 16px;
  }

  .title {
    font-size: 30px;
    background: url("~@/assets/images/yd-title-bottom.png") center bottom
      no-repeat;
    background-size: 30%;
  }

  .company-main li {
    padding: 1.5% 0;
  }

  .company-main li span {
    font-size: 8px;
  }

  .company-main li span:nth-of-type(1) {
    padding: 0 1.5%;
  }

  .company-main li span img {
    width: 50%;
    vertical-align: middle;
  }

  .company-box {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue